import { useQueryCallbackWithProfile } from '@tv2/lib-offspring/api/graphql/useQueryCallbackWithProfile';
import { useQueryWithProfile } from '@tv2/lib-offspring/api/graphql/useQueryWithProfile';
import { buildClientHeaders } from '../../api/headers';
import { SaveSearchHistoryEntryInput } from '../../__generated__/api/types';
import { DeleteAllSearchHistoryDocument } from './__generated__/DeleteAllSearchHistory';
import { DeleteSearchHistoryEntryDocument } from './__generated__/DeleteSearchHistoryEntry';
import { SaveSearchHistoryEntryDocument } from './__generated__/SaveSearchHistoryEntry';
import { SearchHistoryDocument, SearchHistoryQuery } from './__generated__/SearchHistory';
import { QueryDataResponse } from '@tv2/lib-graphql/core';

export function useSearchHistory(): {
  fetching: boolean;
  searchHistory: SearchHistoryQuery['searchHistory'];
  refetch: (headers?: Record<string, string>) => Promise<QueryDataResponse<SearchHistoryQuery>>;
} {
  const headers: Record<string, string> = buildClientHeaders();
  const response = useQueryWithProfile({
    query: SearchHistoryDocument,
    requestPolicy: 'cache-and-network',
    headers,
  });

  return {
    fetching: response.fetching,
    searchHistory: response.data?.searchHistory ?? [],
    refetch: response.refetch,
  };
}

export function useSaveSearchHistoryEntry() {
  const headers: Record<string, string> = buildClientHeaders();
  const saveSearchHistoryEntry = useQueryCallbackWithProfile({
    query: SaveSearchHistoryEntryDocument,
    headers,
  });

  return (input: SaveSearchHistoryEntryInput) => saveSearchHistoryEntry({ input });
}

export function useDeleteSearchHistoryEntry() {
  const headers: Record<string, string> = buildClientHeaders();
  const deleteSearchHistoryEntry = useQueryCallbackWithProfile({
    query: DeleteSearchHistoryEntryDocument,
    headers,
  });

  return (guid: string) => deleteSearchHistoryEntry({ guid });
}

export function useDeleteAllSearchHistory() {
  const headers: Record<string, string> = buildClientHeaders();
  const deleteAllSearchHistory = useQueryCallbackWithProfile({
    query: DeleteAllSearchHistoryDocument,
    headers,
  });

  return () => deleteAllSearchHistory();
}
